<template>
  <v-container data-aos="fade">
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm4>
        <v-img :src="image" class="elevation-2 flyer"></v-img>
        <v-btn color="primary" href="mailto:contact@chefnaturelle.com?subject=A French Christmas">Book Now</v-btn>
      </v-flex>
      <v-flex xs12 sm7>
        <h1>A French Christmas</h1>
        <v-layout class="pricing-details" row justify-space-between>
          <v-flex xs8 class="text-xs-left">
            Saturday 14th Dec 2019 - 7pm to 10pm - Hertford
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            £39
          </v-flex>
        </v-layout>
        <p class="font-weight-bold">
          The party season is about to kick off and you are invited to celebrate Christmas with us!
        </p>
        <p class="font-weight-bold">
          This special edition is inspired by Stéphanie’s Gascony roots with a
          <a href="#" @click.prevent="showMenu=true">menu</a> showcasing classic French recipes with a twist.
          It will be festive, moreish and incredibly nourishing!
        </p>
        <p>
          Bringing people together to enjoy the art of good food is at the heart of these Farm to Table series:
          taking place in the convivial
          <a href="https://mudlarksgarden.org.uk/cafe/" target="_blank">Mudlarks Garden Charity Café</a>
          in Hertford, bring friends and family or come alone to meet other lovely local people!
          Your meal will be prepared with love and care using seasonal and primarily organic ingredients while
          supporting local businesses. You will have the opportunity to pair your dinner with a wine
          selected by Cavavin, Hertford (available to buy from
          <a href="https://www.cavavin.co.uk/contact/" target="_blank">their shop</a>
          beforehand, tasting notes provided upon booking) or bring other drinks - no corkage fee!
        </p>
        <p>
          The evening will begin at 7pm with a signature Gascony apéritif and canapés (non-alcoholic alternative
          available on request). You will have a little time to get comfy and get to know the other guests before
          finding your seat and tucking into your feast.
        </p>
        <p>The <a href="#" @click.prevent="showMenu=true">set menu</a> is only £39 and includes apéritif, canapés, a 3-course meal and a surprise to take home!</p>
        <p class="font-weight-bold" style="text-align: left">
          Places are limited so book your seat now by emailing Stéphanie
          <Contact subject="A French Christmas"></Contact>
        </p>
        <p>See you at the table!</p>
        <div class="terms">
          <p>Please note that the bathroom is located on the first floor with no lift.</p>
          <p>Unfortunately, this event is not suitable for anyone suffering from food allergies as the food is freshly
            prepared in a kitchen which uses allergens. If you have any food intolerances, please
            <contact-link subject="A French Christmas"></contact-link>
            before booking and we will be happy to discuss alternatives.
          </p>
        </div>
      </v-flex>
    </v-layout>
    <MenuDialog :show="showMenu" @close="showMenu=false"></MenuDialog>
  </v-container>
</template>

<script>
import ContactLink from '@/components/ContactLink'
import Contact from '@/components/Contact'
import MenuDialog from '@/components/MenuDialog'

export default {
  components: {
    Contact,
    ContactLink,
    MenuDialog,
  },
  data: () => ({
    image: require('@/assets/images/a-french-christmas-flyer.jpg?vuetify-preload'),
    showMenu: false,
  })
}
</script>

<style scoped>
h1 {
  color: rgb(0,94,54);
  font-family: 'Karla', sans-serif;
  font-weight: bold;
  text-transform: none;
  font-size: 35px;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms p {
  font-size: 15px;
  font-style: italic;
}

.pricing-details {
  color: rgb(0,94,54);
  border-bottom: 1px solid rgb(0,94,54);
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(0,94,54);
  font-size: 25px;
}
</style>
